import dynamic from 'next/dynamic';

export const DynamicFilterSettingsMobilePopoversV2 = dynamic(
  () =>
    import(
      /* webpackChunkName: 'FilterSettingsMobilePopoversV2.client' */ './FilterSettingsMobilePopoversV2.client'
    ),
  {
    ssr: false,
  },
);
